// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../fe-workerportal/node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".checkedGroupDetail .checkboxGroup .checkboxList:nth-last-child(n+2):after{content:\",\";display:inline-block;margin-right:3px}", ""]);
// Exports
module.exports = exports;
